import {
    ROOT,
    GET_ALL_DYNAMIC,
    DETAIL_DYNAMIC,
    UPDATE_DYNAMIC,
    CREATE_DYNAMIC,
    REMOVE_DYNAMIC,
    GET_PRODUCT_DYNAMIC,
    UPDATE_STATUS_DYNAMIC,
    SORT_DYNAMIC,
    DETAIL_SCHEDULE_DYNAMIC,
    UPDATE_SCHEDULE_DYNAMIC
  } from "@/_helpers/constant.js";
  import { requestOptions, handleResponse } from "@/_helpers";
  
  function getAll(data) {
    return fetch(ROOT + GET_ALL_DYNAMIC, requestOptions.post(data))
      .then(handleResponse)
      .then(data => {
        return data;
      });
  }
  function detailDynamic(data) {
    return fetch(ROOT + DETAIL_DYNAMIC + `/${data}`, requestOptions.get())
      .then(handleResponse)
      .then(data => {
        return data;
      });
  }
  function updateDynamic(data) {
    return fetch(ROOT + UPDATE_DYNAMIC, requestOptions.post(data))
      .then(handleResponse)
      .then(data => {
        return data;
      });
  }
  function createDynamic(data) {
    return fetch(ROOT + CREATE_DYNAMIC, requestOptions.post(data))
      .then(handleResponse)
      .then(data => {
        return data;
      });
  }

  function removeDynamic(data) {
    return fetch(ROOT + REMOVE_DYNAMIC + `/${data}`, requestOptions.get())
      .then(handleResponse)
      .then(data => {
        return data;
      });
  }

  function getProduct() {
    return fetch(ROOT + GET_PRODUCT_DYNAMIC, requestOptions.get())
      .then(handleResponse)
      .then(data => {
        return data;
      });
  }

  function updateStatus(data) {
    return fetch(ROOT + UPDATE_STATUS_DYNAMIC, requestOptions.post(data))
      .then(handleResponse)
      .then(data => {
        return data;
      });
  }

  function sort(data) {
    return fetch(ROOT + SORT_DYNAMIC, requestOptions.post(data))
      .then(handleResponse)
      .then(data => {
        return data;
      });
  }

  function detailSchedule() {
    return fetch(ROOT + DETAIL_SCHEDULE_DYNAMIC, requestOptions.get())
      .then(handleResponse)
      .then(data => {
        return data;
      });
  }

  function updateScheduleDynamic(data) {
    return fetch(ROOT + UPDATE_SCHEDULE_DYNAMIC, requestOptions.post(data))
      .then(handleResponse)
      .then(data => {
        return data;
      });
  }
  
  //#endregion
  export const dynamicService = {
    getAll,
    detailDynamic,
    updateDynamic,
    createDynamic,
    removeDynamic,
    getProduct,
    updateStatus,
    sort,
    detailSchedule,
    updateScheduleDynamic
  };
  